// You can customize the template with the help of this file
import { env } from 'env';

const flavor = env.VITE_FLAVOR ? env.VITE_FLAVOR : 'default/';
const base = env.VITE_PUBLIC_PATH || '/';
const logo = `${base}assets/${flavor}logo.png`;
const logoNameAlt = `${base}assets/${flavor}logoName${flavor == 'default/' ? '-light' : ''}.png`;
const logoName = `${base}assets/${flavor}logoName.png`;
//Template config options
const themeConfig = {
  app: {
    appName: 'Webtrack',
    appLogoImage: logoName,
    appLogoImageAlt: logoNameAlt,
    appLogo: logo
  },
  layout: {
    isRTL: false,
    skin: 'bordered', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false,
      isPinner: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'sticky', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: env.VITE_CUSTOMIZER === 'true' ? true : false,
    scrollTop: true // Enable scroll to top button
  }
};
export default themeConfig;
